import { Observable, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { Lang } from './config/general.config';
import pl from '../assets/i18n/pl.json';

const translations: Record<string, object> = {
  [Lang.PL]: pl
};

export class StaticTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<object> {
    return of(translations[lang] ?? translations[Lang.PL]);
  }
}

export function createTranslateLoader(): TranslateLoader {
  return new StaticTranslateLoader();
}
